// export const API = 'https://api.wildmindsadmin.com';
export const BUCKET = process.env.REACT_APP_BUCKET_URL;
export const API = process.env.REACT_APP_API_URL;
// export const API = "http://134.209.213.188:8080";
// export const BUCKET = `http://134.209.213.188:8080/files`;
